// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2GmgP","cell":"ColumnAccessor_cell__2lK7y","firstCellAccent":"ColumnAccessor_firstCellAccent__2B8Sz"};